import { useContent } from '../content/ContentContext.jsx'
import { Em } from '../components/Em.jsx'

export function HeroSection() {
  const { content } = useContent()
  const h = content.hero
  return (
    <section className="hero" id="sec-hero">
      <div className="hero-bg">
        <div className="grad"></div>
        <div className="tex"></div>
        <div className="vig"></div>
      </div>
      <div className="hero-inner">
        <div className="eyebrow hlabel">{h.label}</div>
        <h1>
          <Em pre={h.pre} em={h.em} post={h.post} />
        </h1>
        <p className="sub">{h.sub}</p>
      </div>
      <div className="scroll-cue">
        <span className="ln"></span> SCROLL
      </div>
    </section>
  )
}
